import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { DataContext } from "../../../../../context/data/DataContext";
import useResponsive from "../../../../../hooks/useResponsive";
import {Layout} from "antd";
import '../../../../../assets/scss/theme/admin/style.scss';

export const PrintLayout: React.FC = () => {
    const dataContext = useContext(DataContext);
    const { isMobile } = useResponsive();

    useEffect(() => {
        if (isMobile) {
            dataContext.setSidebarVisible(false);
        }
    }, [isMobile]);

    return (
        <Layout id={"admin-theme-wrapper"} className={`app-wrapper admin-theme-wrapper ${dataContext.sidebarVisible ? '' : 'hide-sidebar'}` }>
            <Outlet />
        </Layout>
    )
}
